import React from "react";
import * as c from "./pricingAddOns.module.scss";
import classNames from "classnames";
import TextLink from "@components/atoms/TextLink";

const PricingAddOns = ({ icon, title, description, link, price }) => (
  <div className={c.container}>
    <div className={c.content}>
      <div className={c.icon}>{icon}</div>
      <h5 className={classNames("h5", c.title)}>{title}</h5>
      <p className={classNames("p3", c.description)}>{description}</p>
      <TextLink to={link} className={c.link} textClassName={c.linkText} icon="arrow">
        Learn More
      </TextLink>
    </div>
    <div className={c.priceContainer}>
      <p className={classNames("p4", c.price)}>{price}</p>
    </div>
  </div>
);

export default PricingAddOns;
